import React, { useState, useEffect } from "react";
import SuccessModel from "./SuccessModel";
import { SelectPopup } from "./SelectPopup";

export default function SearchPopup({ isOpen, onClose }) {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showPopup, setShowPopup] = useState(false)
  const [selectedHsn, setSelectedHsn] = useState("");
  const [relatedHsn, setRelatedHsn] = useState("");

  useEffect(() => {
    if (isOpen) {
      setShowSuccess(false);
    }
  }, [isOpen]);

  if (!isOpen && !showSuccess) return null;
  const handleAdd = () => {
    setShowSuccess(true);
  };

  const handleSelectClick = () => {
    setShowPopup(true);
  }
  const handleDeleteClickWithData = (hsnCode) => {
    setSelectedHsn(hsnCode);
    setRelatedHsn(`Related to ${hsnCode}`);
    setShowPopup(false);
  };

  return (
    <>
      {!showSuccess && isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 ">
          <div className="bg-white p-4 rounded-xl shadow-xl w-full max-w-[600px] ">
            <div className="flex justify-between items-center mt-1">
              <h3 className="text-lg text-gray-900">Add Related Products</h3>
              <button onClick={onClose} className="text-gray-600 text-2xl">
                &times;
              </button>
            </div>
            <hr />
            <div className="space-y-4 mt-5">
              <div>
                <label className="block text-gray-700">
                  SAC<span className="text-red-500">*</span>
                </label>

                <div>

                </div>


                <div className="max-w-[400px] mt-1 border px-3 py-2 rounded">

                  <div className="flex justify-between">
                    <div className="text-gray-400">{selectedHsn || 'Select Hsn'}</div>

                    <span className="text-gray-500 text-sm cursor-pointer" onClick={handleSelectClick}>▼</span>
                  </div>
                </div>

                <div className="mt-3">
                  <label className="flex text-gray-700">
                    Default Unit<span className="text-red-500">*</span>
                  </label>
                  <div className="max-w-[400px] mt-1 border px-3 py-2 rounded">
                    <div className="flex justify-between">
                      <div className="text-gray-400">Enter Unit</div>

                      <span className="text-gray-500 text-sm cursor-pointer"></span>
                    </div>
                  </div>
                </div>

              </div>


              <div>
                <label className="block text-gray-700">
                  Related SAC<span className="text-red-500">*</span>
                </label>
                <textarea rows="3"
                  value={relatedHsn}
                  onChange={(e) => setRelatedHsn(e.target.value)}
                  placeholder="Enter Related Products HSN code …Use ( , ) for multiple HSN"
                  className="w-full h-36 mt-1 border px-3 py-2 rounded focus:outline-none"
                />

              </div>
            </div>

            <div className="flex justify-end mt-4">
              <button
                className="bg-blue-600 text-white px-10 py-1 rounded"
                onClick={handleAdd}
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Model */}
      {showSuccess && (
        <SuccessModel
          onClose={() => {
            setShowSuccess(false);
            onClose();
          }} />
      )}
      {showPopup && (
        <div className="absolute top-30 ml-20 z-50 bg-white border rounded-2xl">
          <SelectPopup
            onClose={() => {
              setShowPopup(false);

            }}
            onDeleteClickWithData={handleDeleteClickWithData}
          />

        </div>
      )}

    </>
  );
}
